import { jsPDF } from "jspdf";

import { Typography, Box, Avatar, Button } from "@mui/material";
import TagRole from "../../components/tag-role";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context";
import logo from "../../assets/images/logo_new.png";
import useCompanies from "../../hooks/companies";
import useClients from "../../hooks/clients";
import { Container, ContainerActions } from "./styles";
import companyLogo from "./../../assets/images/logo-pdf.png";
const Invoice = ({
  service,
  close,
}: {
  service?: ServiceOrder;
  close: () => void;
}) => {
  const userWorker = useContext(UserContext);
  const [open, setOpen] = useState(true);
  const { get: getCompanies } = useCompanies();
  const { get: getClients } = useClients();

  const [company, setCompany] = useState<Company>();
  const [client, setClient] = useState<Client>();
  useEffect(() => {
    getCompanies().then((companies) => {
      console.log(companies);
      const companyAuxi = companies.filter(
        (company) => company.id === userWorker.user?.companyId
      )[0];
      setCompany(companyAuxi);
    });
  }, [userWorker]);
  useEffect(() => {
    getClients().then((clients) => {
      const clientAuxi = clients.filter((client) => {
        return client.id === service?.clientId;
      })[0];
      setClient(clientAuxi);
    });
  }, [service]);
  const cellStyles =
    "border-solid border border-black w-[50%]  border-t-[0] border-l-[0] p-[8px]";

  const header = [
    { title: "Qty Ordered", textRight: true },
    { title: "Product Code", textRight: false },
    { title: "Description", textRight: false },
    { title: "Unit Price", textRight: true },
    { title: "Net Amount", textRight: true },
  ];

  const inputTotal = (value?: string) => (
    <div className="flex justify-between ">
      <span>£</span>
      {value ? <span>{value}</span> : <input></input>}
    </div>
  );
  const tableTotal = [
    { title: "Total travel cost", value: inputTotal(service?.totalRide) },
    { title: "Total work hours", value: inputTotal(service?.totalTime) },
    { title: "Total material", value: inputTotal(service?.totalMaterials) },
    { title: "Order Total", value: inputTotal(service?.totalPrice) },
  ];

  const currentDate = new Date();
  const ukDate = currentDate.toLocaleDateString("en-GB");
  return (
    <Container id="conteudo">
      <ContainerActions>
        <Button
          onClick={() => {
            close();
          }}
          variant="contained"
          color="secondary"
          fullWidth
        >
          Go back
        </Button>
        <Button
          onClick={async () => {
            //window.print();

            const doc = new jsPDF({
              orientation: "portrait", // em pé
              unit: "px", // pixels
              format: "a4", // tamanho A4
            });
            const img = new Image();
            img.src = companyLogo;

            img.onload = () => {
              doc.addImage(img, "PNG", 10, 10, 50, 50);
            };

            const conteudo = document.getElementById("conteudo");
            console.log(conteudo);
            if (conteudo)
              await doc.html(conteudo, {
                callback: function (doc) {
                  doc.save("invoice-" + service?.invoiceNumber + ".pdf");
                },
                x: 1,
                y: 1,
                html2canvas: {
                  scale: 0.5, // Reduz o conteúdo pra caber na folha
                  useCORS: true,
                },
              });
          }}
          variant="contained"
          color="primary"
          fullWidth
        >
          Print
        </Button>
      </ContainerActions>
      <div className="bg-[#fff] flex flex-col justify-between h-full">
        <div className="flex flex-col gap-[12px]">
          <div className="flex row justify-between ">
            <div>
              <div>{company?.name}</div>
              <div>{company?.address}</div>
              <div>
                Tel:
                {company?.phone}
              </div>
              <div>
                Email:
                {company?.email}
              </div>
              <div className="flex row ">
                <div className="font-bold	">VAT Reg No: </div>
                {company?.vat}
              </div>
            </div>
            <div>
              <img src={companyLogo} alt="" width="150px" height={"150px"} />
            </div>
          </div>
          <div className="flex row justify-between gap-[20px]">
            <div className="border-solid border border-black rounded-lg w-full p-[12px]  mt-[24px]">
              <div>{client?.name}</div>
              <div>{client?.address?.description}</div>
            </div>
            <div className="w-full">
              <div className="flex flex-row w-full  pb-[12px]">
                <div className="w-[50%]">
                  <b>SALES ORDER </b>
                </div>
                <b>Page 1</b>
              </div>
              <div className="border-solid border border-black rounded-lg w-full">
                <table className="border-solid  border-black rounded-lg w-full">
                  <tr>
                    <td className={cellStyles}>
                      <b>Sales Order No </b>
                    </td>
                    <td className={cellStyles}>{service?.invoiceNumber}</td>
                  </tr>
                  <tr>
                    <td className={cellStyles}>
                      <b>Sales Order Date</b>
                    </td>
                    <td className={cellStyles}>{ukDate}</td>
                  </tr>
                  <tr>
                    <td className={cellStyles}>
                      <b>Order No</b>
                    </td>
                    <td className={cellStyles}>
                      <input></input>
                    </td>
                  </tr>
                  <tr>
                    <td className={cellStyles + " border-b-[0]"}>
                      <b>Account Ref</b>
                    </td>
                    <td className={cellStyles + " border-b-[0]"}>
                      {client?.id}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <b>This is not a V.A.T Invoice</b>
          <table className="[&_td]:pl-[8px] [&_th]:pl-[8px]">
            <tr className="border-solid border  border-black w-full">
              {header.map(({ title, textRight }) => (
                <th
                  className={
                    (textRight ? "text-right" : "text-left") + "  pb-[12px]"
                  }
                >
                  <b>{title}</b>
                </th>
              ))}
            </tr>
            {[
              [
                "1",
                "Travel cost",
                service?.pricePerMile + "/mile",
                service?.totalRide,
              ],
              [
                "1",
                "Work hours cost",
                service?.pricePerHour + "/hour",
                service?.totalTime,
              ],
            ].map(([amountUsed, name, pricePerItem, totalPriceItem]) => (
              <tr>
                <td className="text-right">{amountUsed}</td>
                <td></td>
                <td>{name}</td>
                <td className="text-right">{pricePerItem}</td>
                <td className="text-right">{totalPriceItem}</td>
              </tr>
            ))}
            {service?.items.map(
              ({ amountUsed, name, pricePerItem, totalPriceItem }) => (
                <tr>
                  <td className="text-right">{amountUsed}</td>
                  <td></td>
                  <td>{name}</td>
                  <td className="text-right">{pricePerItem}</td>
                  <td className="text-right">{totalPriceItem}</td>
                </tr>
              )
            )}
          </table>
        </div>
        <div className="border-t border-solid border-[#000]">
          <div className="flex row justify-between gap-[20px] mt-[24px]">
            <div className="border-solid border border-black rounded-lg w-full p-[12px]  "></div>

            <div className="border-solid border border-black rounded-lg w-full">
              <table className="border-solid  border-black rounded-lg w-full">
                {tableTotal.map(({ title, value }) => (
                  <tr>
                    <td className={cellStyles}>
                      <b>{title}</b>
                    </td>
                    <td className={cellStyles}>{value}</td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Invoice;
